<template>
    <section class="section has-bleeding-image">
        <div class="container">
            <div class="row align-items-center">
                <div class="hidden-xs hidden-sm hidden-md col-lg-5">
                    <img
                        class="section__bleeding_img"
                        src="./../assets/images/newsletter-icon-subscribe-newsletter.png"
                    />
                </div>
                <div class="col-xs-12 col-lg-7">
                    <div class="block--alt">
                        <h2>{{ $t('account.subscribe.title') }}</h2>
                        <p>
                            {{ $t('account.subscribe.sub_title') }}
                        </p>
                        <SignUpFormMail />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import SignUpFormMail from './SignUpFormMail.vue';

export default {
    components: { SignUpFormMail },
};
</script>
